import { ReactNode } from "react"
import { css, cx } from "@emotion/css"

export function FooterLayout({
  children,
  customClass,
}: {
  children: ReactNode
  customClass?: string
}) {
  return <div className={cx(styles.root, customClass)}>{children}</div>
}

const styles = {
  root: css`
    width: 100%;
    position: relative;
    padding: 8px 0px 8px 8px;
    border-radius: 0 0 10px 10px;
  `,
}
